// UGC videos (main-product "ugc_videos" block).
// Click a tile to play, click again to pause. No native controls: the custom
// play button shows whenever the video is not playing. Only one video plays at a time.
if (!customElements.get("ugc-videos")) {
	customElements.define(
		"ugc-videos",
		class UgcVideos extends HTMLElement {
			connectedCallback() {
				this.addEventListener("click", this.onClick.bind(this));

				this.querySelectorAll(".product__ugc-item video").forEach((video) => {
					const item = video.closest(".product__ugc-item");
					video.controls = false;
					video.addEventListener("play", () => item.classList.add("is-playing"));
					video.addEventListener("pause", () => item.classList.remove("is-playing"));
					video.addEventListener("ended", () => item.classList.remove("is-playing"));
				});
			}

			onClick(event) {
				const item = event.target.closest(".product__ugc-item");
				if (!item) return;

				const video = item.querySelector("video");
				if (!video) return;

				if (!video.paused && !video.ended) {
					video.pause();
					return;
				}

				this.querySelectorAll("video").forEach((other) => {
					if (other !== video) other.pause();
				});

				video.play();
			}
		}
	);
}
